import { DatasourceDomain } from '@mode/shared/contract-common';
import { AccountResource } from '../accounts/account-response.types';
import { getEmbedded, getHref } from '@mode/shared/util-halogen';
import { DatasourceResource } from '../datasources/datasource-response.types';

export function toPublicDatasource(resource: DatasourceResource): DatasourceDomain.Datasource {
  if (!resource.public) {
    throw new Error('Not a public datasource');
  }

  let displayName = 'Public Warehouse';
  if (resource.asleep) {
    displayName += ' (unavailable)';
  }

  return {
    id: resource.id,
    token: resource.token,
    name: resource.name,
    createdAt: resource.created_at,
    displayName,
    public: resource.public,
    isDefault: true,
    forEveryone: resource.default_access_level !== 'None',
    defaultAccessLevel: resource.default_access_level,
    adapter: resource.adapter,
    vendor: resource.vendor,
    queryable: resource.queryable,
    asleep: resource.asleep,
    hasExpensiveUpdates: resource.has_expensive_schema_updates,

    permissions: {
      canUpdateSchema: false,
    },

    links: {
      home: null,
      settings: null,
    },
  };
}

export function toDatasource(resource: DatasourceResource, org: AccountResource): DatasourceDomain.Datasource {
  let displayName = resource.name;
  if (resource.public) {
    displayName = 'Public Warehouse';
  }

  if (resource.asleep) {
    displayName += ' (unavailable)';
  }

  const refreshForm = getEmbedded<any>(resource, 'new_data_source_schema_update')?._forms;

  return {
    id: resource.id,
    token: resource.token,
    name: resource.name,
    createdAt: resource.created_at,
    displayName,
    public: resource.public,
    isDefault: org.default_data_source_token === resource.token,
    forEveryone: resource.default_access_level !== 'None',
    defaultAccessLevel: resource.default_access_level,
    adapter: resource.adapter,
    vendor: resource.vendor,
    queryable: resource.queryable,
    asleep: resource.asleep,
    hasExpensiveUpdates: resource.has_expensive_schema_updates,

    permissions: {
      canUpdateSchema: refreshForm != null,
    },

    links: {
      home: getHref(resource, 'web_home'),
      settings: getHref(resource, 'web'),
    },
  };
}
